// import CartTimer from "@shared/components/application/data-display/CartTimer/CartTimer.web";
import { domElementIds } from "@shared/constants/common";
import Box from "@ui-kit/layout/Box/Box.web";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import dynamic from "next/dynamic";
import { useLayoutEffect } from "react";
import { useMobileWebviewContext } from "@shared/contexts/MobileWebviewContext/MobileWebviewContext";
import { NavBarBannersProps } from "./NavBarBanners.props";
import NavBarExchangeBanner from "./NavBarExchangeBanner.web";

const CartTimer = dynamic(
  () =>
    import(
      "@shared/components/application/data-display/CartTimer/CartTimer.web"
    ),
  {
    ssr: false,
  }
);

/**
 * Contains all navbar banners that can be displayed on the site.
 * Currently, has: Cart Timer Banner, Exchange Banner
 */
export default function NavBarBanners({
  isDetailsPage = false,
  onHeightChange,
}: NavBarBannersProps) {
  const { webviewValueAdapter } = useMobileWebviewContext();

  useLayoutEffect(() => {
    const el = document.getElementById(domElementIds.navbarBannerId);
    if (!el) return undefined;

    const update = () => {
      const height = el.offsetHeight;
      document.documentElement.style.setProperty(
        "--navbar-banners-height",
        `${height}px`
      );
      onHeightChange?.(height);
    };

    update();
    const observer = new ResizeObserver(update);
    observer.observe(el);

    return () => {
      observer.disconnect();
      document.documentElement.style.removeProperty("--navbar-banners-height");
      onHeightChange?.(0);
    };
  }, [onHeightChange]);

  return (
    <Flex
      top="none"
      direction="column"
      id={domElementIds.navbarBannerId}
      zIndex="navbarTabs"
      position={webviewValueAdapter({ web: "sticky", webview: "relative" })}
    >
      {/* Cart Timer Banner */}
      {/* Hide the banner when not on a purchase page */}
      {isDetailsPage && (
        <Box position="sticky" backgroundColor="red.100">
          <Box
            w="full"
            maxWidth="1520"
            mx="auto"
            px={{ base: "lg", sm: "3xl" }}
          >
            <CartTimer />
          </Box>
        </Box>
      )}
      {/* Exchange Banner */}
      <NavBarExchangeBanner />
    </Flex>
  );
}
